/**
 * Returns today's date as "YYYY-MM-DD" in the browser's local timezone.
 * Use this instead of new Date().toISOString().split('T')[0], which returns
 * the UTC date and is wrong for IST users before 5:30 AM.
 */
export function localDateStr(d = new Date()) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
